import { Dispatch, SetStateAction, useCallback, useState } from 'react'
import { AnyObject } from '../../types/global'
import { produce } from 'immer'

export type ChangeCallback<T extends AnyObject, K extends keyof T> = (val: T[K], key: K) => void

const useStateWithChange = <T extends AnyObject>(
  initialValue: T
): [T, Dispatch<SetStateAction<T>>, ChangeCallback<T, keyof T>] => {
  const [state, setState] = useState<T>(initialValue)

  const handleChange: ChangeCallback<T, keyof T> = useCallback((val, key) => {
    if (typeof key === 'string') {
      if (key.includes('.')) {
        setState((prev) => {
          return produce(prev, (draft) => {
            let nestedObject = draft
            const path = key.split('.')
            for (let i = 0; i < path.length - 1; ++i) {
              nestedObject = nestedObject[path[i]]
            }

            // @ts-ignore
            nestedObject[path[path.length - 1]] = val

            return draft
          })
        })
      } else {
        setState((prev) => ({ ...prev, [key]: val }))
      }
    }
  }, [])

  return [state, setState, handleChange]
}

export default useStateWithChange
